import { render } from "./ActivitiesReport.vue?vue&type=template&id=642524f0"
import script from "./ActivitiesReport.vue?vue&type=script&lang=js"
export * from "./ActivitiesReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__